import { actionTypes } from './actions';

const initialState = {
  list: {
    loading: false,
    list: [],
    count: 0,
    params: {}
  },
  one: {
    loading: false,
    data: null
  }
};

const ExecutorsAvailableReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_LIST: {
      const { payload = {} } = action;
      const { list = {} } = state;
      return {
        ...state,
        list: {
          ...list,
          ...payload
        }
      };
    }
    case actionTypes.GET_ONE: {
      const { one = {} } = state;
      const { payload = {} } = action;
      return {
        ...state,
        one: {
          ...one,
          ...payload
        }
      };
    }
    case actionTypes.CLEAR_ONE: {
      return {
        ...state,
        one: {
          ...initialState
        }
      };
    }
    case actionTypes.EXECUTOR_AVAILABLE_ONE_LOADING: {
      const { one = {} } = state;
      const { loading } = action;
      return {
        ...state,
        one: {
          ...one,
          loading
        }
      };
    }
    default:
      return state;
  }
};

export default ExecutorsAvailableReducer;
